export default {
  selectedControl: {},
  selectedSection: {},
  selectedControlSection: {},
  formControls: [],
  formSections: [],
  updatedControl: {},
  test: 'hello world'
}
